import { Component, OnInit, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { SalesOpportunityService } from '../services/sales-opportunity-service';
import { SalesOpportunity } from '../models/sales-opportunity-model';
import { ISalesFunnelLayoutChild } from '../shared/sales-funnel-child.module';

@Component({
  selector: 'app-sales-funnel',
  standalone: true,
  imports: [FormsModule],
  templateUrl: './sales-funnel-component.html',
  styleUrls: ['./sales-funnel-component.scss'],
})
export class SalesFunnelComponent implements OnInit, ISalesFunnelLayoutChild {
  private router = inject(Router);
  private salesService = inject(SalesOpportunityService);

  // UI state
  searchQuery = '';
  sortBy: 'address' | 'postcode' | 'district' = 'address';
  filterStatus = '';
  selectedLead: SalesOpportunity | null = null;

  // Required by ISalesFunnelLayoutChild
  salesFunnelIndex = 0;

  // Data
  leads: SalesOpportunity[] = [];
  filteredLeads: SalesOpportunity[] = [];

  ngOnInit(): void {
    this.salesService.getAllOpportunities().subscribe({
      next: (data) => {
        console.log('Loaded opportunities:', data);
        this.leads = data ?? [];
        this.filteredLeads = [...this.leads];
      },
      error: (err) => console.error('Failed to load opportunities:', err),
    });
  }

  filterLeads(): void {
    const q = this.searchQuery.trim().toLowerCase();
    let filtered = [...this.leads];

    if (q) {
      filtered = filtered.filter(
        (op) =>
          op.singleLineAddress.toLowerCase().includes(q) || op.postcode.toLowerCase().includes(q),
      );
    }

    if (this.filterStatus.trim()) {
      filtered = filtered.filter(
        (op) => (op.status || '').toLowerCase() === this.filterStatus.toLowerCase(),
      );
    }

    this.filteredLeads = filtered;
  }

  sortLeads(): void {
    if (this.sortBy === 'address') {
      this.filteredLeads.sort((a, b) => a.singleLineAddress.localeCompare(b.singleLineAddress));
    } else if (this.sortBy === 'postcode') {
      this.filteredLeads.sort((a, b) => a.postcode.localeCompare(b.postcode));
    } else if (this.sortBy === 'district') {
      this.filteredLeads.sort((a, b) =>
        a.localAuthorityDistrict.localeCompare(b.localAuthorityDistrict),
      );
    }
  }

  selectLead(lead: SalesOpportunity): void {
    this.selectedLead = lead;
  }

  goToEligibility(): void {
    if (this.selectedLead) {
      this.router.navigate(['/package-offer']);
    }
  }

  openMap(lead: SalesOpportunity): void {
    this.router.navigate(['/map'], {
      queryParams: {
        address: lead.singleLineAddress,
        postcode: lead.postcode,
        lat: lead.latitude,
        lng: lead.longitude,
      },
    });
  }

  // Track function for @for; improves perf & avoids re-renders
  trackByUprn = (_: number, item: SalesOpportunity) => item.uprn;
}
